module.exports = __webpack_public_path__ + "static/media/seb.abea08f8.jpg";